import { BaseComponent2 } from '../../_common/client/base-component2';
import { initStarRating } from './star-rating/init-star-rating';
import { initSubmitButton } from './submit-button/init-submit-button';
import { init5ScaleRatingSelections } from './scores-selection/init-5-scale-rating-selections';
import { getReviewSubmissionClientData } from './helper/get-review-submission-client-data';
import { trackComponentInit } from './tracking/track-component-init';
import { setCloseUrlOnFocusedDialog } from './close-page-button/set-close-url-on-focused-dialog';
import { initSmileyBar } from './smiley-bar/init-smiley-bar';
import { WindowLocation } from '../../_common/client/window-location';
import FileUpload from './file-upload/file-upload';
import { FormWidget } from './form-widget';
import { initGuidelines } from './guidelines/guidelines';
import { CR_SUBMISSION } from './constants';

export class CustomerReviewSubmissionPageComponent extends BaseComponent2 {
    public rootSelector = '.js_cr_submission-page';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;

        const rootElement = this.getRootElement();

        trackComponentInit({ rootElement });

        setCloseUrlOnFocusedDialog(rootElement);

        const reviewSubmissionClientData = getReviewSubmissionClientData({ rootElement });
        if (reviewSubmissionClientData.status === 'CAN_SUBMIT') {
            const formElement = this.getChildElement(CR_SUBMISSION.PAGE.FORM_SELECTOR);
            const formWidgets: FormWidget[] = [];
            init5ScaleRatingSelections({ rootElement });
            initStarRating({ rootElement });
            initSmileyBar(rootElement);
            if (formElement) {
                formWidgets.push(FileUpload.initialize({ formElement }));
            }
            initGuidelines(rootElement, reviewSubmissionClientData.variation.id);
            initSubmitButton({ rootElement, formWidgets });
        } else if (reviewSubmissionClientData.status === 'NOT_LOGGED_IN') {
            WindowLocation.assign(reviewSubmissionClientData.redirectToLoginUrl);
            return;
        }
    }
}
